var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('auction-dialog', {
    attrs: {
      "title": "낙찰 결과 통보서",
      "width": "1440"
    },
    on: {
      "open": _vm.init,
      "close": _vm.destroy
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }, {
      key: "default",
      fn: function fn() {
        var _vm$program;

        return [_c('div', {
          staticClass: "mb-10 mb-md-14"
        }, [_c('h3', {
          staticClass: "tit tit--xs"
        }, [_vm._v(" " + _vm._s(_vm.hall) + " "), _c('small', {
          staticClass: "pl-4"
        }, [_vm._v(_vm._s((_vm$program = _vm.program) === null || _vm$program === void 0 ? void 0 : _vm$program.subject))])])]), _c('v-data-table', _vm._b({
          staticClass: "v-data-table--default",
          attrs: {
            "disable-sort": "",
            "hide-default-footer": "",
            "mobile-breakpoint": "768"
          },
          scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
            return header.hasOwnProperty('formatter');
          }), function (header) {
            return {
              key: "item.".concat(header.value),
              fn: function fn(_ref2) {
                var value = _ref2.value;
                return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
              }
            };
          }), {
            key: "item.work",
            fn: function fn(_ref3) {
              var _value$author, _value$author$name;

              var value = _ref3.value;
              return [_vm._v(" " + _vm._s(value === null || value === void 0 ? void 0 : (_value$author = value.author) === null || _value$author === void 0 ? void 0 : (_value$author$name = _value$author.name) === null || _value$author$name === void 0 ? void 0 : _value$author$name.ko) + " "), _c('br'), _vm._v(" " + _vm._s(value === null || value === void 0 ? void 0 : value.subject) + " ")];
            }
          }, {
            key: "header.delivery",
            fn: function fn(_ref4) {
              var header = _ref4.header;
              return [_c('div', {
                staticClass: "pa-10"
              }, [_vm._v(_vm._s(header.text))]), _c('v-divider', {
                staticClass: "grey-da"
              }), _c('v-row', {
                attrs: {
                  "no-gutters": ""
                }
              }, [_c('v-col', {
                staticClass: "pa-10"
              }, [_vm._v("직접방문시")]), _c('v-col', {
                staticClass: "d-none d-md-flex",
                attrs: {
                  "cols": "auto"
                }
              }, [_c('v-divider', {
                staticClass: "grey-da",
                attrs: {
                  "vertical": ""
                }
              })], 1), _c('v-col', {
                staticClass: "pa-10"
              }, [_vm._v("배송요청시")])], 1)];
            }
          }, {
            key: "item.delivery",
            fn: function fn() {
              return [_c('v-row', {
                staticClass: "fill-height",
                attrs: {
                  "no-gutters": ""
                }
              }, [_c('v-col', {
                attrs: {
                  "align-self": "center",
                  "cols": "12",
                  "md": ""
                }
              }, [_c('div', {
                staticClass: "d-md-none font-weight-medium"
              }, [_vm._v("직접방문시")]), _vm._v(" KRW 0 ")]), _c('v-col', {
                staticClass: "d-none d-md-flex",
                attrs: {
                  "cols": "auto"
                }
              }, [_c('v-divider', {
                staticClass: "grey-da",
                attrs: {
                  "vertical": ""
                }
              })], 1), _c('v-col', {
                attrs: {
                  "align-self": "center",
                  "cols": "12",
                  "md": ""
                }
              }, [_c('div', {
                staticClass: "d-md-none font-weight-medium"
              }, [_vm._v("배송요청시")]), _vm._v(" KRW " + _vm._s(_vm.delivery) + " ")])], 1)];
            },
            proxy: true
          }, {
            key: "footer",
            fn: function fn() {
              var _vm$totalCharge, _vm$totalCharge$forma;

              return [_c('div', {
                staticClass: "pa-12 d-flex align-center justify-center grey-ef"
              }, [_c('span', {
                staticClass: "font-size-14 font-size-md-16 grey-68--text"
              }, [_vm._v(" 총 결제금액 : "), _c('span', {
                staticClass: "font-weight-medium primary--text"
              }, [_vm._v(" KRW " + _vm._s((_vm$totalCharge = _vm.totalCharge) === null || _vm$totalCharge === void 0 ? void 0 : (_vm$totalCharge$forma = _vm$totalCharge.format) === null || _vm$totalCharge$forma === void 0 ? void 0 : _vm$totalCharge$forma.call(_vm$totalCharge)))])])]), _c('v-divider', {
                staticClass: "grey-da"
              })];
            },
            proxy: true
          }], null, true)
        }, 'v-data-table', {
          headers: _vm.headers,
          items: _vm.items
        }, false), [_c('v-divider', {
          staticClass: "grey-da"
        })], 1), _c('div', {
          staticClass: "mt-16 mt-md-20"
        }, [_c('v-card', {
          staticClass: "grey-ef",
          attrs: {
            "tile": "",
            "elevation": "0"
          }
        }, [_c('v-card-text', {
          staticClass: "pa-16 pa-md-24"
        }, [_c('p', {
          staticClass: "font-size-14 font-weight-bold line-height-16 grey-68--text"
        }, [_vm._v(" ※ 대금 결제 및 배송 절차 ")]), _c('ul', {
          staticClass: "dot-list mt-4"
        }, [_c('li', [_vm._v("낙찰된 작품은 낙찰을 철회할 수 없습니다. 기타 자세한 사항은 당사의 약관에 따릅니다.")]), _c('li', [_vm._v("낙찰자는 낙찰일로부터 7일 이내에, 낙찰가와 낙찰수수료, 부가가치세를 합친 구매대금을 아래의 입금계좌로 입금하셔야 합니다.")]), _c('li', [_vm._v("구매대금은 현금, 자기앞수표, 계좌이체 등으로 지급하실 수 있습니다.")]), _c('li', {
          staticClass: "dashed-item"
        }, [_vm._v("낙찰 수수료에 한해서는 신용카드 결제가 가능합니다")]), _c('li', {
          staticClass: "dashed-item"
        }, [_vm._v("신용카드로 결제하실 경우는 당사를 방문하셔야 가능합니다.")]), _c('li', [_vm._v("이체 시 낙찰자와 송금계좌 예금주가 다른 경우, 반드시 입금 통장 표시에 낙찰자명 기재 부탁 드립니다.")])]), _c('p', {
          staticClass: "font-size-14 font-weight-bold line-height-16 grey-68--text pt-16"
        }, [_vm._v(" ※ 입금계좌 : 우리은행 1002-752-126350 황규성 ")])])], 1)], 1)];
      },
      proxy: true
    }], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }